<template>
    <v-text-field
        class="edit-table-cell"
        ref="input"
        :value="editValue" 
        @input="onValueChanged"
        type="number"
        :clearable="clearable"
        autofocus
        single-line
        hide-details
        outline
        @blur="blur"
        @keydown.enter="enter"
        :rules="rules"
        :loading="loading"
        :disabled="loading">
        <template v-slot:append>
            <v-icon
                v-if="isDirty && !loading" 
                @click.stop="reset">
                undo
            </v-icon>
        </template>
    </v-text-field>
</template>

<script>
export default {
    components: {

    },
    props: {
        value: {
            type: String,
            required: true
        },
        rules: {
            type: Array,
            required: false,
            default() {
                return []
            }
        },
        loading: {
            type: Boolean,
            required: false,
            default: false
        },
        clearable: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data(){
        return {
            localValue: null
        };
    },
    computed: {
        editValue(){
            if(this.localValue != null){
                return this.localValue;
            }

            return this.value;
        },
        isDirty(){
            return this.editValue != this.value;
        }
    },
    methods: {
        reset(isEnter){
            this.localValue = null;
            this.$emit("close", isEnter);
        },
        onValueChanged(newValue){
            if(this.loading){
                return;
            }
            
            this.localValue = newValue;
        },
        blur() {
            this.submit(false);
        },
        enter() {
            this.submit(true);
        },
        submit(isEnter = false){
            if(this.loading){
                return;
            }

            this.$nextTick(() => {
                if(!this.isDirty){
                    this.reset(isEnter);
                } else if(this.$refs.input && this.$refs.input.validate()){
                    this.$emit("input", {value: this.localValue, isEnter: isEnter});
                }
            });
        }
    },
    created(){
        
    },
    mounted(){
        // Highlight all text
        let input = this.$refs.input.$refs.input;
        input.select();
    }
}
</script>

<style>
/* Chrome, Safari, Edge, Opera */
.edit-table-cell input::-webkit-outer-spin-button,
.edit-table-cell input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
.edit-table-cell input[type=number] {
  -moz-appearance: textfield;
}
</style>